import React from 'react';
import SelkirkIcon from './SelkirkIcon';

/**
 * Icon + text label (headings, buttons).
 */
const IconText = ({
  icon,
  iconSize = 24,
  iconVariant,
  children,
  className = '',
  as: Tag = 'span',
  gap = '0.5rem',
}) => (
  <Tag
    className={`icon-text ${className}`.trim()}
    style={{ display: 'inline-flex', alignItems: 'center', gap }}
  >
    <SelkirkIcon name={icon} size={iconSize} variant={iconVariant} decorative />
    <span>{children}</span>
  </Tag>
);

export default IconText;
